// FormDialogStepper — wizard step indicator strip extracted from FormDialog
// to keep the parent slim per plan §6 split threshold (>250 LOC).
//
// Not exported from the composition barrel — internal to FormDialog only.

import type { WizardStep } from "./FormDialog";

interface FormDialogStepperProps {
  steps: WizardStep[];
  currentIndex: number;
}

export function FormDialogStepper({ steps, currentIndex }: FormDialogStepperProps) {
  return (
    <nav
      aria-label="Wizard steps"
      style={{
        display: "flex",
        gap: 6,
        padding: "10px 20px",
        borderBottom: "1px solid var(--color-border-subtle)",
        fontSize: 12,
      }}
    >
      {steps.map((step, i) => {
        const reached = i <= currentIndex;
        const active = i === currentIndex;
        return (
          <span
            key={step.key}
            data-step-key={step.key}
            aria-current={active ? "step" : undefined}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              color: reached ? "var(--color-text)" : "var(--color-text-muted)",
              fontWeight: active ? 600 : 500,
            }}
          >
            <span
              aria-hidden="true"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 18,
                height: 18,
                borderRadius: 9999,
                fontSize: 11,
                background: reached ? "var(--color-text)" : "var(--color-bg-subtle)",
                color: reached ? "white" : "var(--color-text-muted)",
              }}
            >
              {i + 1}
            </span>
            {step.title}
            {i < steps.length - 1 ? (
              <span aria-hidden="true" style={{ color: "var(--color-text-subtle)", marginLeft: 4 }}>
                ›
              </span>
            ) : null}
          </span>
        );
      })}
    </nav>
  );
}
